// extracted by mini-css-extract-plugin
export default {"preview-container":"saved-report-drag-preview-item__preview-container--n8oCz","previewContainer":"saved-report-drag-preview-item__preview-container--n8oCz"};